import { ReactElement } from "react";
import * as css from "../styles/executiveSummaryReportManagement.module.scss";
import { Field, Hint, Label, Range, Select } from "@zendeskgarden/react-forms";
import brandLight from "../../../assets/icons/brand/brand_light.png";
import addRounded from "../../../assets/images/executive_summary/add_rounded.png";
import { ReactComponent as InfoStrokeIcon } from '@zendeskgarden/svg-icons/src/16/info-stroke.svg';


export interface IExecutiveSummaryPDFCoverPreviewProps {
    clientDisplayName: string;
    primaryColor: string;
    secondaryColor: string;
    previewBackgroundImage: string | null;
    previewLogoImage: string | null;
    pdfImagePosition: string | null;
    pdfLogoSize: number;
    onPositionChange: (position: string) => void;
    onSizeChange: (position: number) => void;
}

export default function ExecutiveSummaryPDFCoverPreview({
    clientDisplayName,
    primaryColor,
    secondaryColor,
    previewBackgroundImage,
    previewLogoImage,
    pdfImagePosition,
    pdfLogoSize,
    onSizeChange,
    onPositionChange,
}: IExecutiveSummaryPDFCoverPreviewProps): ReactElement {
    return (
        <div className={css.pdfPreviewWrapper}>
            <div className={css.fields}>
                <Field>
                    <Label>Image Position</Label>
                    <Hint>Depending on image aspect ratio, you may not see a change</Hint>
                    <Select value={pdfImagePosition ?? "center"} onChange={(evt) => onPositionChange(evt.target.value)}>
                        <option value="top">Top</option>
                        <option value="center">Center</option>
                        <option value="bottom">Bottom</option>
                    </Select>
                </Field>

                <Field>
                    <Label>Client Logo Size</Label>
                    <Range value={pdfLogoSize} step={1} min={0} max={100} onChange={((evt) => onSizeChange(+evt.target.value))} />
                </Field>

                <p className={css.infoText}><InfoStrokeIcon className={css.infoIcon} />Size and position of elements in the PDF preview may not exactly match the final, generated file.</p>
            </div>

            <div
                className={css.coverPreview}
                style={{
                    backgroundImage: `url(${previewBackgroundImage})`,
                    backgroundPosition: pdfImagePosition ?? "center",
                }}
            >
                <div className={css.overlayColor} style={{backgroundColor: primaryColor}}></div>

                <div className={css.titleBar} style={{backgroundColor: primaryColor, borderTop: `3px solid ${secondaryColor}`}}>
                    <span className={css.property}>Bowman Estates</span>
                    <span className={css.subText}>{new Date().getFullYear()} Operating Budget</span>
                    <span className={css.subText}>Presented by {clientDisplayName}</span>
                </div>

                <div className={css.footer}>
                    <img className={css.vizLogo} src={brandLight} />
                    <img className={css.joinIcon} src={addRounded} />
                    {previewLogoImage &&
                        <img src={previewLogoImage} style={{width: `${pdfLogoSize}px`}} />
                    }
                </div>
            </div>
        </div>
    );
}
